import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api/api.module';

@Component({
	selector: 'app-stat-new-checkout',
	templateUrl: './stat-new-checkout.component.html',
	styleUrls: ['./stat-new-checkout.component.scss']
})
export class StatNewCheckoutComponent implements OnInit {

	constructor(private api: ApiService) { }
  // lineChart
  public barChartOptions:any = {
  	scaleShowVerticalLines: false,
  	responsive: true
  };
  public barChartLabels:string[] = [];
  public barChartType:string = 'line';
  public barChartLegend:boolean = true;
  
  public barChartData:any[] = [
  {data: [], label: 'Last Week'},
  {data: [], label: 'This Week'}
  ];

  public barChartColor:Array<any> = [
    { // grey
      backgroundColor: 'rgba(255, 139, 105, 0.1)',
      pointBackgroundColor: 'rgba(255, 139, 105, 0.1))',
      borderColor: 'rgba(255, 139, 105, 0.5)',
    },
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,.1)',
    }
    ]
  // events
  public chartClicked(e:any):void {
  	console.log(e);
  }
  
  public chartHovered(e:any):void {
  	console.log(e);
  }

  Last7Days () {

  	var result = [];
  	for (var i=0; i<7; i++) {
  		var d = new Date();
  		d.setDate(d.getDate() - i);
  		result.push( `${d.getDate()}/${d.getMonth()+1}` )
  	}
  	this.barChartLabels = result
  	return(result.join(','));
  }

  ngOnInit() {
  	this.Last7Days()
  	this.api.getCheckoutStateWeek().subscribe(data =>{
  		var tmp = [
  		{data: [], label: 'This Week'},
  		{data: [], label: 'Last Week'},
  		]
  		for (var i in data.body.Period) {
  			tmp[0].data.push(data.body.Period[i].Count)
  			tmp[1].data.push(data.body.LastPeriod[i].Count)
  		}
  		this.barChartData = tmp
  	})
  }

}
